export const emailStatuses = ['verified', 'not_verified', 'bounce', 'spamreport'] as const;

export type EmailStatus = (typeof emailStatuses)[number];

export interface UserMeta {
  badge: number;
  not_seen_discussions_count: number;
  not_seen_cases_count: number;
}

export interface UserPreferences {
  skip_pms_encoding_warning?: boolean;
}

export interface User {
  id: number;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  verified_phone: string | null;
  profile_picture_url: string | null;
  lab_name: string | null;
  unconfirmed_email: string | null;
  last_sign_in_at: string | null;
  rpps_id: string | null;
  created_at: string;
  stop_sms: boolean;
  chat_by_email: boolean;
  is_deactivated: boolean;
  email_status: EmailStatus;
  cgu_accepted_at: string | null;
  preferences: UserPreferences;
}
